import React, { useState } from 'react';
import axios from 'axios';
const url = "http://localhost:3000/portfolio_med";


const ProjectAdder = () => {
   

  async function convertToBase64(file) {
    try {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
  
      await new Promise((resolve, reject) => {
        fileReader.onload = () => {
          resolve(fileReader.result); // Resolve with the result as a string
        };
  
        fileReader.onerror = (error) => {
          reject(error);
        };
      });
  
      return fileReader.result;
    } catch (error) {
      throw error;
    }
  }
  

  const [organisation, setOrganisation] = useState("");
  const [description, setDescription] = useState("");
  const [abrev, setAbrev] = useState("");
  const [name, setName] = useState("");
  const [images, setImages] = useState([]);
  const [selectedChoice, setSelectedChoice] = useState("");
  const [projectLink, setprojectLink] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'name') {
      setName(value);
    } else if (name === 'description') {
      setDescription(value);
    } else if (name === 'organisation') {
      setOrganisation(value);
    } else if (name === 'jobType') {
      setSelectedChoice(value);
    } else if (name === 'projectLink') {
      setprojectLink(value);
    }

  };

  const createProject = async (newProject) => {
    try {
      console.log('', newProject);
      
      await axios.post(url, newProject);
    } catch (error) {
      console.log(error);
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
  };

  const handleSubmit = async(e) => {
    e.preventDefault();

    const ImagesAfter = [];
    images.forEach((image) => {
      const im = convertToBase64(image).then((i) => {
        return ' ' + i;
      });
      ImagesAfter.push(im);
    });

    Promise.all(ImagesAfter)
  .then((resolvedImages) => {
    console.log('', resolvedImages);
    
    let project =  {
      name:name,
      description:description,
      organisation:organisation,
      images:resolvedImages,
      jobType:selectedChoice,
      projectLink:projectLink
    }
    console.log(project);
    createProject(project);

    console.log('Uploaded');
    // Handle the resolved images
  })
  .catch((error) => {
    console.error('Error:', error);
    // Handle the error
  });
  
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className='projectadder'>
        <h3>Add a Project to the Portfolio</h3>

        <label htmlFor="file-upload" className="custom-file-upload">
         
        </label>

        <label htmlFor="description">Project description</label>
        <input
          type="text"
          label="description"
          name="description"
          value={description}
          onChange={handleInputChange}
        />

        <label htmlFor="name">Project name</label>
        <input
          type="text"
          label="name"
          name="name"
          id="Projectname"
          value={name}
          onChange={handleInputChange}
        />

      <label htmlFor="organisation">Project Organisation</label>
        <input
          type="text"
          label="organisation"
          name="organisation"
          value={organisation}
                  onChange={handleInputChange}/>
      <label htmlFor="projectLink">Project Link</label>
        <input
          type="text"
          label="projectLink"
          name="projectLink"
          value={projectLink}
          onChange={handleInputChange}/>
        
      <div>
          <h1>Select Project Type</h1>
      <label>
        <input
          type="radio"
          name="jobType"
          value="Remote Job"
          onChange={handleInputChange}
          checked={selectedChoice === 'Remote Job'}
        />
        Remote Job
      </label>
      <br />
      <label>
        <input
          type="radio"
          name="jobType"
          value="Internship"
          onChange={handleInputChange}
          checked={selectedChoice === 'Internship'}
        />
        Internship
      </label>
      <br />
      <label>
        <input
          type="radio"
          name="jobType"
          value="Proprietary"
          onChange={handleInputChange}
          checked={selectedChoice === 'Proprietary'}
        />
        Proprietary
      </label>
      <br />
      <div>
        <h2>Selected Choice:</h2>
        <p>{selectedChoice}</p>
      </div>
    </div>

        <input type="file" name="images" multiple onChange={handleImageChange} />
        <div className='ProjectImages'>
            {
            images[0] && images.map((img, index) => (
              <img src={img} alt="" key={index} />
))
            }
        </div>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default ProjectAdder;